import api from './api'

export const loanService = {
  getTypes: () => {
    return api.get('/loans/types')
  },

  getAll: (params = {}) => {
    return api.get('/loans', { params })
  },

  getById: (noPinjaman) => {
    return api.get(`/loans/${noPinjaman}`)
  },

  calculate: (data) => {
    return api.post('/loans/calculate', data)
  },

  apply: (data) => {
    return api.post('/loans/apply', data)
  },

  approve: (noPinjaman, disetujui, catatan = '') => {
    return api.post(`/loans/${noPinjaman}/approve`, { disetujui, catatan })
  },

  disburse: (noPinjaman) => {
    return api.post(`/loans/${noPinjaman}/disburse`)
  },

  payInstallment: (noPinjaman, angsuranKe, jumlahBayar, denda = 0) => {
    return api.post(`/loans/${noPinjaman}/pay`, {
      angsuranKe,
      jumlahBayar,
      denda
    })
  }
}
